module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_pp3_9005.d4e9e3c8.png";